import { EventEmitter } from 'modules/event-emitter';

export interface NotebookEvents {
  'refresh-clinical-drugs': void;
}

export const notebookEmitter = new EventEmitter<NotebookEvents>();
